$(document).ready(function() {
    $('.engraving').removeClass('loading');
    let lastFocusedDiv = null;
    const maxLength = $('.engraving-form').attr('data-chars-numbers');

    function getCharCount(div) {
        const clonedDiv = $(div).clone();
        clonedDiv.find('span').replaceWith('X'); // Заменяем содержимое на 'X' или любой другой символ
        const textContent = clonedDiv.text();
        return textContent.length;
    }

    function updateCharCount(div) {
        let text = div.text().trim();
        let count = getCharCount(text);
        div.next('.char-count').text(`Количество символов: ${count}`);
    }
    
    function textInputListener() {
        $(this).find('br').remove();
        const $div = $(this);
        const currentLength = getCharCount($div);

        if (currentLength > maxLength) {
            // Если длина текста превышает максимальное значение, предотвращаем ввод
            const text = $div.html();
            const tempDiv = $('<div>').html(text);

            // Удаляем лишние символы, сохраняя структуру HTML
            let charCount = 0;
            tempDiv.contents().each(function() {
                if (this.nodeType === Node.TEXT_NODE) {
                    const textNode = this;
                    const textLength = textNode.textContent.length;
                    if (charCount + textLength > maxLength) {
                        textNode.textContent = textNode.textContent.slice(0, maxLength - charCount);
                        charCount = maxLength;
                    } else {
                        charCount += textLength;
                    }
                } else if (this.nodeType === Node.ELEMENT_NODE) {
                    charCount += 1;
                }
            });

            $div.html(tempDiv.html());
            // Перемещаем курсор в конец текста
            const range = document.createRange();
            const sel = window.getSelection();
            range.setStart($div[0], 1);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
            return
        }

        drawText();
        const item = $(this).closest('.engraving-form-lines-item-input-wrapper');
        const counter = item.find('.engraving-form-lines-item-count span');
        counter.text(currentLength);
    }

    function drawText() {
        const textLines = [
            $('#line1').html(),
            $('#line2').html(),
            $('#line3').html()
        ];

        textLines.forEach((line, index) => {
            if (line) {
                $(`#engraving-text${index + 1}`).removeClass('engraving-canvas-text-hidden');
                $(`#engraving-text${index + 1}`).html(line);
            } else {
                $(`#engraving-text${index + 1}`).addClass('engraving-canvas-text-hidden');
            }
        });
    }

    function changeFont() {
        const selectedFont = $('input[name="font"]:checked').val();

        if (selectedFont == 'Handwritten typography') {
            $('.engraving-canvas-text').removeClass('engraving-canvas-text-garamond');
        } else {
            $('.engraving-canvas-text').addClass('engraving-canvas-text-garamond');
        }
    }

    // Отслеживаем последний активный div
    $('.engraving-form-lines-item-input').on('focus', function() {
        lastFocusedDiv = $(this);
    });

    $('#addSun').click(function() {
        const currentLength = getCharCount(lastFocusedDiv);
        if  (lastFocusedDiv && (currentLength < maxLength)) {
            lastFocusedDiv.append('<span contenteditable="false">S</span>');
            drawText();
            const item = lastFocusedDiv.closest('.engraving-form-lines-item-input-wrapper');
            const counter = item.find('.engraving-form-lines-item-count span').text(currentLength + 1);
        }
    });

    $('#addMoon').click(function() {
        const currentLength = getCharCount(lastFocusedDiv);
        if  (lastFocusedDiv && (currentLength < maxLength)) {
            lastFocusedDiv.append('<span contenteditable="false">M</span>');
            drawText();
            const item = lastFocusedDiv.closest('.engraving-form-lines-item-input-wrapper');
            const counter = item.find('.engraving-form-lines-item-count span').text(currentLength + 1);
        }
    });

    $('#addStar').click(function() {
        const currentLength = getCharCount(lastFocusedDiv);
        if (lastFocusedDiv && (currentLength < maxLength)) {
            lastFocusedDiv.append('<span contenteditable="false">T</span>');
            drawText();
            const item = lastFocusedDiv.closest('.engraving-form-lines-item-input-wrapper');
            const counter = item.find('.engraving-form-lines-item-count span').text(currentLength + 1);
        }
    });

    $('#addHeart').click(function() {
        const currentLength = getCharCount(lastFocusedDiv);
        if  (lastFocusedDiv && (currentLength < maxLength)) {
            lastFocusedDiv.append('<span contenteditable="false">H</span>');
            drawText();
            const item = lastFocusedDiv.closest('.engraving-form-lines-item-input-wrapper');
            const counter = item.find('.engraving-form-lines-item-count span').text(currentLength + 1);
        }
    });

    function replaceSpans(html) {
        // Создаем временный элемент для работы с HTML
        var tempDiv = $('<div></div>').html(html);

        tempDiv.find('span').each(function() {
            if ($(this).text() === 'S') {
                $(this).replaceWith('*sun*');
            }

            if ($(this).text() === 'M') {
                $(this).replaceWith('*moon*');
            }

            if ($(this).text() === 'T') {
                $(this).replaceWith('*star*');
            }

            if ($(this).text() === 'H') {
                $(this).replaceWith('*heart*');
            }
        });

        // Возвращаем измененный HTML
        return tempDiv.html();
    }

    function addTocart() {
        let items = [];
        const form = $('.engraving-form');

        $('.engraving').addClass('loading');

        const productId = form.attr('data-product-id');
        const engravingId = form.attr('data-engraving-id');

        const productObject = {
            id: productId,
            quantity: 1
        }

        const engravingObject = {
            id: engravingId,
            "properties": {
                'Engraving line 1': replaceSpans($('#line1').html()),
                'Engraving line 2': replaceSpans($('#line2').html()),
                'Engraving line 3': replaceSpans($('#line3').html()),
                'Engraving font': $('input[name="font"]:checked').val(),
            },

            quantity: 1
        }

        items.push(productObject);
        items.push(engravingObject);

        const data = {
            items
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error adding product to cart');
                }
                return response.json();
            })
            .then(cart => {
                window.location.replace("/cart");
                $('.engraving').removeClass('loading');
            })
            .catch(error => {
                alert('Error:', error);
                console.error('Ошибка:', error);
            });

    }
    
    
    $('.engraving-form-lines-item-input').on('input', textInputListener);

    $('input[name="font"]').change(changeFont);

    $('#submit-button').click(addTocart);

});